import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

import Tooltipable from "~/components/effects/tooltipable";

const AuthTooltip = ({ title, body, placement = "top", className = "" }) => {
  const content = (
    <div className="auth-tooltip-content">
      <span>{body}</span>
    </div>
  );

  return (
    <Tooltipable
      trigger="click"
      placement={placement}
      text={content}
      className={`d-inline-flex align-middle ${className}`.trim()}
      tooltipContentClassName="text-left"
    >
      <button
        type="button"
        className="btn btn-link border-0 d-inline-flex align-items-center justify-content-center p-0 auth-tooltip-button"
        aria-label={title}
      >
        <FontAwesomeIcon icon={["far", "info-circle"]} aria-hidden="true" />
      </button>
    </Tooltipable>
  );
};

AuthTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  placement: PropTypes.string,
  className: PropTypes.string,
};

export default AuthTooltip;
